<div mat-dialog-title style="margin:0px;">
    <span>Project Future Scores</span>
</div>

<mat-dialog-content>

    <span>
        The columns shown are based on the Slot Weight Formula defined for this course's grading type. When grades have
        not been posted, only the first calculated period and all contributing periods will be displayed. When the grades have been posted
        all contributing periods up to the first unposted period, and the final grade will be displayed.
    </span>

</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
    </div>
</mat-dialog-actions>